import React, {Fragment} from "react";
import BasicModal from "../../../../common/BasicModal";
import {basicModalStyle} from "../../Utilities/basicModalStyles";
import FreshdeskSetupForm from "./FreshdeskSetupForm";

export default function FreshdeskSetupModal({open, handleClose, handleOpen}) {
    return(
        <Fragment>
            <BasicModal
                open={open}
                handleClose={handleClose}
                handleOpen={handleOpen}
                title={'Connect with Freshdesk'}
                style={basicModalStyle}
            >
                <FreshdeskSetupForm
                    description={'Please copy and paste your Freshdesk credentials here:'}
                    buttonLabel={'Submit'}
                    openInNewTab={true}
                    handleClose={handleClose} />
            </BasicModal>
        </Fragment>
    )
}